import request from '@/utils/request'


const basePath = `/api/user`

export function getCurrentUserInfo(params) {
    return request({
        url: `${basePath}/current`,
        method: 'get',
    })
}

/**
 * 查询用户分页列表
 * @param params
 * @returns {*}
 */
export function findUserPage(params) {
    return request({
        url: `${basePath}/page`,
        method: 'get',
        params: params
    })
}

/**
 * 添加用户
 * @param data
 * @returns {AxiosPromise}
 */
export function addUser(data) {
    return request({
        url: `${basePath}`,
        method: 'post',
        data: data
    })
}

/**
 * 更新用户
 * @param id
 * @param data
 * @returns {*}
 */
export function updateUser(id, data) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.10.0`,
        method: 'put',
        data: data
    })
}

/**
 * 移除用户
 * @param ids
 * @returns {AxiosPromise}
 */
export function removeUser(ids) {
    return request({
        url: `${basePath}`,
        method: 'delete',
        params: {
            ids: ids
        }
    })
}

/**
 * 修改面貌
 * @param id
 * @param data
 * @returns {AxiosPromise}
 */
export function changePwd(id, data) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.10.0/password`,
        method: 'put',
        data: data
    })
}

/**
 * 添加用户
 * @param data
 * @returns {AxiosPromise}
 */
export function batchAddUsers(data) {
    return request({
        url: `${basePath}/batch`,
        method: 'post',
        data: data
    })
}
